(() => {
  'use strict';
  const key = 'wpc_marketing_history_v1';
  const selector = 'form[action*="go.whirlpool-center.de/l/1029631/"],form[data-wpc-newsletter-shield]';
  const lifetime = 90 * 86400000;
  const pageId = crypto.randomUUID();
  let history = [];
  let loaded = false;
  let pageRecorded = false;
  let queued = false;
  const clean = (value, max = 160) => String(value || '').trim().slice(0, max);
  const permissions = () => {
    try {
      const p = window.Shopify && window.Shopify.customerPrivacy;
      return !!(p && p.marketingAllowed());
    } catch (_) { return false; }
  };
  const prune = (items) => {
    const cutoff = Date.now() - lifetime;
    const seen = new Set();
    const result = items.filter(t => {
      const valid = t && /^[a-zA-Z0-9_-]{8,80}$/.test(t.id || '') && Date.parse(t.at) >= cutoff && Date.parse(t.at) <= Date.now() + 300000 && !seen.has(t.id);
      if (valid) seen.add(t.id);
      return valid;
    });
    const bounded = result.length > 20 ? [result[0], ...result.slice(-19)] : result;
    // Keep below the Salesforce transport field limit, including its JSON envelope.
    while (bounded.length > 1 && JSON.stringify(bounded).length > 30000) bounded.splice(1, 1);
    return JSON.stringify(bounded).length <= 30000 ? bounded : [];
  };
  const refresh = () => {
    // An API that is still loading is not a withdrawal of consent.
    if (typeof window.Shopify?.customerPrivacy?.marketingAllowed !== 'function') return;
    if (!permissions()) {
      history = []; loaded = false; pageRecorded = false;
      try { localStorage.removeItem(key); } catch (_) {}
      return;
    }
    if (!loaded) {
      loaded = true;
      try { const saved = JSON.parse(localStorage.getItem(key)); history = prune(Array.isArray(saved) ? saved : []); } catch (_) { history = []; }
    }
    if (!pageRecorded) {
      const p = new URLSearchParams(location.search);
      const read = (...names) => { for (const n of names) { const v = clean(p.get(n)); if (v && !/[{}]/.test(v)) return v; } return ''; };
      const click = n => { const v = clean(p.get(n), 255); return /^[A-Za-z0-9._~-]{1,255}$/.test(v) ? v : ''; };
      const gclid = click('gclid'), gbraid = click('gbraid'), wbraid = click('wbraid');
      let source = read('utm_source');
      if (gclid || gbraid || wbraid) source = 'google';
      const campaign = read('utm_campaign');
      if (source || campaign || gclid || gbraid || wbraid) {
        const t = { id: pageId, at: new Date().toISOString(), source, medium: read('utm_medium') || (gclid || gbraid || wbraid ? 'cpc' : ''), campaign,
          campaignId: read('campaign_id', 'campaignid', 'utm_id'), adgroupId: read('adgroup_id', 'adgroupid', 'adset_id', 'adsetid'),
          adId: read('ad_id', 'adid'), content: read('utm_content'), term: read('utm_term'), gclid, gbraid, wbraid,
          path: clean(location.pathname, 255), storageConsent: 'shopify_marketing_allowed' };
        const last = history[history.length - 1];
        const same = last && ['source','medium','campaign','campaignId','adgroupId','adId','gclid','gbraid','wbraid','content','term'].every(k => (last[k] || '') === t[k]);
        if (!same || Date.now() - Date.parse(last.at) > 1800000) history.push(t);
      }
      pageRecorded = true;
    }
    history = prune(history);
    try { localStorage.setItem(key, JSON.stringify(history)); } catch (_) {}
  };
  const fill = form => {
    let field = form.querySelector('input[name="wpc_marketing_context"]');
    if (!permissions() || !history.length) { if (field) field.remove(); return; }
    if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'wpc_marketing_context'; form.appendChild(field); }
    field.value = JSON.stringify({v:1,touches:history});
  };
  const enrich = () => { queued = false; refresh(); document.querySelectorAll(selector).forEach(fill); };
  const schedule = () => { if (!queued) { queued = true; queueMicrotask(enrich); } };
  document.addEventListener('submit', event => { if (event.target.matches(selector)) { refresh(); fill(event.target); } }, true);
  document.addEventListener('visitorConsentCollected', enrich);
  document.addEventListener('DOMContentLoaded', enrich, {once:true});
  new MutationObserver(records => { if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.(selector) || n.querySelector?.(selector))))) schedule(); }).observe(document.documentElement, {childList:true,subtree:true});
  if (window.Shopify && window.Shopify.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], enrich);
  // Consent managers can initialize Shopify's API after loadFeatures calls back.
  // Capture this landing page once the API is ready, before navigation loses its query.
  let readinessAttempts = 0;
  const awaitPrivacy = () => {
    if (typeof window.Shopify?.customerPrivacy?.marketingAllowed === 'function') { enrich(); return; }
    if (++readinessAttempts < 120) setTimeout(awaitPrivacy, 250);
  };
  awaitPrivacy();
  enrich();
})();
